import { HoldingT } from '@/common/types'

export function calculatePortfolioSummary({
    holdings,
    pledgedSecurityCodes = [],
    hidePledged = false,
}: {
    holdings: HoldingT[]
    pledgedSecurityCodes?: string[]
    hidePledged?: boolean
}) {
    const pledgedSecurities = hidePledged ? pledgedSecurityCodes : []
    const filteredHoldings = holdings.filter((entry) => !pledgedSecurities.includes(entry.securityCode))
    const totalHoldingsValue = filteredHoldings.reduce((acc, cur) => acc + cur.currentValue, 0)
    const totalCost = filteredHoldings.reduce((a, b) => (a ?? 0) + (b.cost ?? 0), 0)
    const totalChange = totalHoldingsValue - totalCost
    const totalChangePercent = totalCost ? (totalChange / totalCost) * 100 : 0

    const changeSinceYesterday = filteredHoldings.reduce((acc, cur) => acc + (cur.dailyChangeValue ?? 0) * cur.units, 0)
    const yesterdaysTotalValue = totalHoldingsValue - changeSinceYesterday
    const changeSinceYesterdayPercent = yesterdaysTotalValue ? (changeSinceYesterday / yesterdaysTotalValue) * 100 : 0

    return {
        totalHoldingsValue,
        totalCost,
        totalChange,
        totalChangePercent,
        changeSinceYesterday,
        changeSinceYesterdayPercent,
    }
}
